/* eslint-disable no-unused-vars */
import React, { CSSProperties } from 'react';
import Modal from '@material-ui/core/Modal';
import { Box, Button, makeStyles, Typography } from '@material-ui/core';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import { CheckBoxLabel } from 'src/components';
import { useCheque } from 'src/hooks/cheque-management/use-cheque';

const useStyles = makeStyles((theme) => ({
  body: {
    position: 'absolute',
    width: '100%',
    maxWidth: 500, // cap width on large screens
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    borderRadius: 8,
    margin: 20,

    [theme.breakpoints.down('sm')]: {
      maxWidth: '90%', // small screens: almost full width
      margin: '0 auto'
    }
  },
  filter: {
    marginTop: 20,
    marginBottom: 20
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  footer: {
    marginTop: 20
  }
}));

const bodyStyle: CSSProperties = {
  top: '20%'
};

const modalStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

interface Props {
  visible: boolean;
  onHandleClose: () => void;
}

export const ChequeListFilterModal = ({ visible, onHandleClose }: Props) => {
  const classes = useStyles();
  const {
    chequeListColumn,
    toggleChequeColumnFilter,
    onToggleAll
  } = useCheque();

  const onToggleItem = (key: string) => {
    toggleChequeColumnFilter(key);
  };

  const onClose = () => {
    onHandleClose();
  };

  return (
    <Modal
      open={visible}
      onClose={onHandleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      style={modalStyle}
    >
      <div style={bodyStyle} className={classes.body}>
        <div className={classes.titleContainer}>
          <Typography variant="h4" color="textPrimary">
            Cheque List Columns Filter
          </Typography>
          <Button endIcon={<DoneAllIcon />} onClick={onToggleAll}>
            Toggle All
          </Button>
        </div>
        {chequeListColumn?.map((column, i) => (
          <CheckBoxLabel
            key={column?.value || i}
            label={column?.name}
            checked={column?.isVisible}
            onChange={() => onToggleItem(column.value)}
          />
        ))}
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-evenly"
          className={classes.footer}
        >
          <Button
            fullWidth
            onClick={onClose}
            color="primary"
            variant="outlined"
          >
            Close
          </Button>
        </Box>
      </div>
    </Modal>
  );
};
